import { FC, useEffect } from "react";
import Modal from "components/Modal";
import type { NotificationItem } from "entities/notification";
import { useMarkNotificationReadMutation } from "features/read-notifications";
import { formatDate } from "shared/utils";

import styles from "./NewsModal.module.css";

interface Props {
  news: NotificationItem;
  onClose: () => void;
}

export const NewsModal: FC<Props> = ({ news, onClose }) => {
  const [markRead] = useMarkNotificationReadMutation();

  useEffect(() => {
    if (!news.read) markRead(news.id);
  }, [news.id, news.read, markRead]);

  return (
    <Modal isOpen onClose={onClose} title={news.title}>
      <p className={styles.date}>{formatDate(Date.parse(news.created_at))}</p>
      <p className={styles.body}>{news.body}</p>
    </Modal>
  );
};
